module.exports = __webpack_public_path__ + "media/images/bg-bonds-a76b4eede889754459ef733862cdc6f0.jpg";